var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "k-main",
    {
      staticClass: "admin-dashboard",
      scopedSlots: _vm._u([
        {
          key: "title",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "title" },
                [
                  _c("h1", { staticClass: "title" }, [_vm._v("Dashboard")]),
                  _c("k-actions", {
                    staticClass: "header-actions",
                    attrs: { actions: _vm.actions, icons: _vm.icons },
                  }),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm.post.sections
        ? _c(
            "div",
            {
              directives: [{ name: "bar", rawName: "v-bar" }],
              staticClass: "main-content",
            },
            [
              _c(
                "div",
                { staticClass: "inner" },
                _vm._l(_vm.sections, function (section) {
                  return _c(
                    "k-objects",
                    _vm._b(
                      { key: section.name, attrs: { icons: _vm.icons } },
                      "k-objects",
                      section,
                      false
                    )
                  )
                }),
                1
              ),
            ]
          )
        : _c(
            "k-objects",
            _vm._b(
              {
                staticClass: "main-content",
                attrs: { icons: _vm.icons, innline: "" },
              },
              "k-objects",
              _vm.post,
              false
            )
          ),
      _c("k-actions", {
        staticClass: "footer-actions",
        attrs: { actions: _vm.actions, icons: _vm.icons, type: "icon-text" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }